import { useState, useEffect } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import MyButton from "../../Components/MyButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";

function Services() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    category_id: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await API.get("/categories");
        setCategories(data.data || data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCategories();
  }, []);

  const handleAdd = () => {
    setFormData({
      name: "",
      category_id: "",
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setFormData({
      name: record.name,
      category_id: record.category_id,
    });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (uuid) => {
    setDeleteId(uuid);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/services/${deleteId}`);
      console.log("تم حذف الخدمة بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      if (editId) {
        await API.put(`/services/${editId}`, formData);
        console.log("تم تعديل الخدمة بنجاح");
      } else {
        await API.post("/services", formData);
        console.log("تم إضافة الخدمة بنجاح");
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: "الاسم", accessor: "name" },
    { header: "التصنيف", accessor: "category.name" },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <>
          <Can permission="service_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Can>
          <Can permission="service_delete">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="الخدمات" />
      {/* <Can permission="service_create">

                <MyButton
                    text="إضافة خدمة"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={editId ? "تعديل الخدمة" : "إضافة خدمة"}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        <MyInput
          label="اسم الخدمة"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          error={errors.name?.[0]}
        />

        <MyInput
          // label="التصنيف"
          as="select"
          value={formData.category_id}
          onChange={(e) =>
            setFormData({ ...formData, category_id: e.target.value })
          }
          options={[
            { value: "", label: "اختر تصنيف" },
            ...categories.map((c) => ({
              value: c.id,
              label: c.name,
            })),
          ]}
          error={errors.category_id?.[0]}
        />
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذه الخدمة؟
      </ModalForm>

      <MyTable
        resource="services"
        columns={columns}
        refreshKey={refreshKey}
        title={"الخدمات"}
        button={{
          text: "إضافة خدمة",
          onClick: handleAdd,
          variant: "success",
          permission: "service_create",
        }}
      />
    </div>
  );
}

export default Services;
